module.exports = __webpack_public_path__ + "img/leave_page_action.f9681bea.svg";